module.exports = __webpack_public_path__ + "img/british-columbia.83a8b582.svg";